var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('carousel',{attrs:{"items":1}},_vm._l((_vm.reverseItems),function(item,i){return _c('div',{key:i},[_c('CrmSubscription',{attrs:{"crm-subscription":item},on:{"prolong":_vm.prolong}})],1)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }